import React, { useEffect, useState } from "react";
import Navbar from "../../../Components/Navbar";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { PaySlipSc } from "./index.sc";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Review from "../../../Components/PayslipComponents/index";
import { useAuthContext } from "../../../hooks";
import { getIndEmployeePay } from "../../../api/Payslip/getIndividulaEmployeePay";
import { getOrgUserDetails } from "../../../api/users/getOrgUserDetails";
function Index() {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const onSubmit = async (e: any) => {
    console.log("I am Here", e);
    // await handleCreateEmployeeDetails(e);
    reset();
  };
  const auth = useAuthContext();
  const navigate = useNavigate();
  const params = useParams()
  const location  = useLocation()
  console.log(location?.search.split("=")[1])

console.log(auth)
const [user, setUser] = useState<any>([]);
const fetchOrgUser = async () => {
  setUser(
    await getOrgUserDetails(
      auth?.userInfo?.orgs[0]?.id,
      params?.employeeId
    )
  );
  console.log("works");
};
const [indPay,setIndPay] = useState<any>([])
  const fetchIndividualPay =async () => {
    const res = await getIndEmployeePay(auth?.userInfo?.orgs[0]?.id,location?.search.split("=")[1])
    setIndPay(res)
  }

  useEffect(() => {
    fetchIndividualPay()
    fetchOrgUser()
  }, [])
  // const userPf = (Number(indPay?.[0]?.basic_pay) * (12/100)) + (Number(indPay?.[0]?.basic_pay) * (3.67/100)) 
  // console.log(userPf)
  // const ePension= (Number(indPay?.[0]?.basic_pay ) *(8.33/100)).toString()
  // console.log(ePension) 

  // const vpr = Number(indPay?.[0]?.basic_pay )* (1/100)
  // console.log(vpr)
  function getWorkingDaysInCurrentMonth() {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();
    const startDate = new Date(currentYear, currentMonth, 1);
    const endDate = new Date(currentYear, currentMonth + 1, 0);
  
    let workingDays = 0;
  
    for (let date = startDate; date <= endDate; date.setDate(date.getDate() + 1)) {
      const dayOfWeek = date.getDay();
  
      // 0 is Sunday, 6 is Saturday
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        workingDays++;
      }
    }
  
    return workingDays;
  }
  
  const numberOfWorkingDays = getWorkingDaysInCurrentMonth();
console.log(numberOfWorkingDays)

  return (
    <PaySlipSc>
      <form className="form-details" onSubmit={handleSubmit(onSubmit)}>
        <div className="inner-container">
          <label>Employee Details:</label>

          <div className="inner-content">
            <div>
              <Form.Group className="w-200 mb-3" controlId="formBasicEmail">
                <Form.Label>Employee Id</Form.Label>
                <Form.Control
                  type="text"
                defaultValue={indPay?.[0]?.employee_id}
                  placeholder="Enter Employee Id"
                  style={{ padding: "0.8rem .75rem" }}
                  {...register("emp_id", {
                    required: {
                      value: true,
                      message: "This is required",
                    },
                  })}
                />
              </Form.Group>
              <Form.Group className="w-200 mb-3 " controlId="formBasicEmail">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Name"
                  defaultValue={indPay?.[0]?.Name}
                  style={{ padding: "0.8rem .75rem" }}
                  {...register("Name", {
                    required: {
                      value: true,
                      message: "This is required",
                    },
                  })}
                />
              </Form.Group>
              <Form.Group className="w-200 mb-3 " controlId="formBasicEmail">
                <Form.Label>Designation</Form.Label>
                <Form.Control
                  type="text"
                defaultValue={user?.[0]?.role}
                  placeholder="Enter Employee Desgination"
                  style={{ padding: "0.8rem .75rem" }}
                  {...register("DOB", {
                    required: {
                      value: true,
                      message: "This is required",
                    },
                  })}
                />
              </Form.Group>
            </div>
            <div>
              <Form.Group className="w-200 mb-3 " controlId="formBasicEmail">
                <Form.Label>Bank Name</Form.Label>
                <Form.Control
                  type="text"
                  defaultValue={"HDFC"}
                  placeholder="Enter bank name  "
                  style={{ padding: "0.8rem .75rem" }}
                  {...register("passport_no", {
                    required: {
                      value: true,
                      message: "This is required",
                    },
                  })}
                />
              </Form.Group>
              <Form.Group className="w-200 mb-3 " controlId="formBasicEmail">
                <Form.Label>Account Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your passport number"
                  style={{ padding: "0.8rem .75rem" }}
                  {...register("address", {
                    required: {
                      value: true,
                      message: "This is required",
                    },
                  })}
                  defaultValue={indPay?.[0]?.acc_no}
                />
              </Form.Group>
              <Form.Group className="w-200 mb-3 " controlId="formBasicEmail">
                <Form.Label>Days Paid</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Employee Pay Date "
                  defaultValue={numberOfWorkingDays}
                  style={{ padding: "0.8rem .75rem" }}
                  {...register("employeeId", {
                    required: {
                      value: true,
                      message: "This is required",
                    },
                  })}
                />
              </Form.Group>
            </div>
          </div>

          <label>Leave Details:</label>
          <div className="inner-content">
            <Form.Group className="w-200 mb-3 " controlId="formBasicEmail">
              <Form.Label>Leave Details</Form.Label>
              <Form.Control
                type="text"
                placeholder="Available PTO"
                defaultValue={20}
                style={{ padding: "0.8rem .75rem" }}
              
              />
            </Form.Group>
            <Form.Group className="w-200 mb-3 " controlId="formBasicEmail">
              <Form.Label>Floating holiday</Form.Label>
              <Form.Control
                type="text"
                placeholder="Available floating holiday "
                style={{ padding: "0.8rem .75rem" }}
              
              />
            </Form.Group>
          </div>
          <label>Earnings:</label>
          <div className="account-details">
            <div className="inner-content">
              <Form.Group className="w-200 mb-3 " controlId="formBasicEmail">
                <Form.Label>Basic Pay</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Basic Pay"
                  defaultValue={indPay?.[0]?.basic_pay}
                  style={{ padding: "0.8rem .75rem" }}
                  {...register("account_number", {
                    required: {
                      value: true,
                      message: "This is required",
                    },
                  })}
                />
              </Form.Group>
              <Form.Group className="w-200 mb-3 " controlId="formBasicEmail">
                <Form.Label>VPR </Form.Label>
                <Form.Control
                  type="text"
                  defaultValue={indPay?.[0]?.vpr}
                  placeholder="Enter VPR details"
                  style={{ padding: "0.8rem .75rem" }}
                  disabled
                />
              </Form.Group>
            </div>
            <label>Deductions:</label>
            <div className="pay-details">
              <div className="pf-insurance">
                <Form.Group className="w-200 mb-3 " controlId="formBasicEmail">
                  <Form.Label>EPF</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="EPF"
                    value={indPay?.[0]?.epf}
                    style={{ padding: "0.8rem .75rem" }}
                   disabled
                  />
                </Form.Group>
{/* 
                <Form.Group className="w-200 mb-3 " controlId="formBasicEmail">
                  <Form.Label>ESI</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="ESI"
                    style={{ padding: "0.8rem .75rem" }}
                    {...register("aadhar_no", {
                      required: {
                        value: true,
                        message: "This is required",
                      },
                    })}
                  />
                </Form.Group> */}
                <Form.Group className="w-200 mb-3 " controlId="formBasicEmail">
                  <Form.Label>TAX </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Tax"
                    value="Nil"
                    disabled
                    style={{ padding: "0.8rem .75rem" }}
                
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </div>
        <div className="buttons-class">
          <Button onClick={() => navigate(`paySlip?employeeId=${location?.search.split("=")[1]}&role=${user?.[0]?.role.split(" ").join(",")}`)}>Download</Button>
          <Button className="submit-button" type="submit">
            Submit
          </Button>
        </div>
      </form>
    </PaySlipSc>
  );
}

export default Index;
